<div class="modal-header">
  <h4 class="modal-title d-flex"><ion-icon name="information-circle" class="ion-3x color-yellow mr-2"></ion-icon>Rating
    not found</h4>
</div>
<div>
  <div class="modal-body">
    <p class="m-0">
      Please provide rating first.
    </p>
    <button class="btn btn__primary closeBtn" (click)="onCloseModal()">Go Back</button>
  </div>
</div>